export default "__VITE_PUBLIC_ASSET__4975011f__"